import { Link } from "react-router-dom";
import { Mail, MapPin, FileText } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0a191a] text-white mt-24">
      <div className="ok-container py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="white" />
          <p className="text-sm text-white/70 mt-4 max-w-md leading-relaxed">
            Wij leveren kracht aan de publieke sector. Overheidskrachten plaatst ervaren professionals bij gemeenten, provincies, rijksoverheid en waterschappen.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <div className="flex items-center gap-2">
              <Mail size={14} /> <a href="mailto:info@overheidskrachten.nl" className="hover:text-white" data-testid="footer-email">info@overheidskrachten.nl</a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin size={14} /> Nederland, landelijke dekking
            </div>
            <div className="flex items-center gap-2">
              <FileText size={14} /> KvK 42135334
            </div>
          </div>
        </div>
        <div className="md:col-span-2">
          <div className="ok-eyebrow" style={{ color: "rgba(255,255,255,0.7)" }}>Platform</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/over-ons" className="hover:text-[#a8d8db]" data-testid="footer-over-ons">Over ons</Link></li>
            <li><Link to="/vacatures" className="hover:text-[#a8d8db]">Vacatures</Link></li>
            <li><Link to="/aanmelden-kandidaat" className="hover:text-[#a8d8db]">Kandidaat aanmelden</Link></li>
            <li><Link to="/aanmelden-inlener" className="hover:text-[#a8d8db]">Inlener aanmelden</Link></li>
            <li><Link to="/kenniscentrum" className="hover:text-[#a8d8db]" data-testid="footer-kenniscentrum">Kenniscentrum</Link></li>
            <li><a href="https://whatsapp.com/channel/0029Vb84JuW72WU4oIK6CS02" target="_blank" rel="noreferrer" className="hover:text-[#a8d8db]">WhatsAppkanaal</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="ok-eyebrow" style={{ color: "rgba(255,255,255,0.7)" }}>Account</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-[#a8d8db]">Inloggen</Link></li>
            <li><Link to="/uitschrijven" className="hover:text-[#a8d8db]">Nieuwsbrief opzeggen</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="ok-eyebrow" style={{ color: "rgba(255,255,255,0.7)" }}>Juridisch</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/algemene-voorwaarden" className="hover:text-[#a8d8db]" data-testid="footer-av">Algemene Voorwaarden</Link></li>
            <li><Link to="/privacyvoorwaarden" className="hover:text-[#a8d8db]" data-testid="footer-privacy">Privacyvoorwaarden</Link></li>
            <li><Link to="/cookieverklaring" className="hover:text-[#a8d8db]" data-testid="footer-cookies">Cookieverklaring</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="ok-container py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Overheidskrachten B.V. Alle rechten voorbehouden.</span>
          <span>Wij leveren kracht aan de publieke sector.</span>
        </div>
      </div>
    </footer>
  );
}
